import { collection, getDocs } from 'firebase/firestore'; 
import React, { useEffect, useState } from 'react';
import { db } from '../FirebaseConfig';
import { Link } from 'react-router-dom';

const Admin = (props) => {
  const [List, setList] = useState([]);
  const [showAddress, setShowAddress] = useState({});

  useEffect(() => {
    const CollectionRef = collection(db, 'Probud');
    const DisplayProducts = async () => {
      const data = await getDocs(CollectionRef);
      setList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    DisplayProducts();
  }, []);

  const handleAddressDisplay = (id) => {
    setShowAddress((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    props.isAuth ? (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center px-4">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-center mb-6 text-gray-700">
          Admin Panel
        </h1>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-blue-600 text-white">
                <th className="p-3 text-left">Product Name</th>
                <th className="p-3 text-left">Price</th>
                <th className="p-3 text-left">Quantity</th>
                <th className="p-3 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {List.map((product) => (
                <React.Fragment key={product.id}>
                  <tr className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="p-3">{product.Name}</td>
                    <td className="p-3">{product.Product}</td>
                    <td className="p-3">{product.Amount}</td>
                    <td className="p-3">
                      <button
                        onClick={() => handleAddressDisplay(product.id)}
                        className="bg-blue-500 text-white py-1 px-2 rounded hover:bg-blue-600 text-xs md:text-sm"
                      >
                        {showAddress[product.id] ? 'Hide Address' : 'Show Address'}
                      </button>
                    </td>
                  </tr>
                  {showAddress[product.id] && (
                    <tr className="bg-gray-100">
                      <td colSpan="4" className="p-3">
                        <div className="border rounded p-3 bg-white shadow">
                          <p className="text-xs md:text-sm">
                            <span className="font-semibold">Address:</span>{' '}
                            {product.Address}
                          </p>
                          <p className="text-xs md:text-sm">
                            <span className="font-semibold">Email:</span>{' '}
                            {product.Email}
                          </p>
                          <p className="text-xs md:text-sm">
                            <span className="font-semibold">Contact Number:</span>{' '}
                            {product.Number}
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    ) : (
      <div className="flex items-center justify-center bg-slate-300 min-h-screen">
        <Link to="/Admin101/LoginPage">
          <div className="border-2 border-gray rounded-lg p-3 text-lg md:text-xl w-[80%] max-w-md h-24 flex items-center justify-center bg-white shadow-sm shadow-black">
            <p>Go and Login</p>
          </div>
        </Link>
      </div>
    )
  );
};

export default Admin;
